<template>
  <div class="pins sousuye">
    <!-- <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
    </van-overlay> -->
    <van-sticky>
      <van-row class="pinsding">
        <van-col span="18">
          <van-cell-group class="sousuokuangs">
            <van-field
              v-model="value"
              left-icon="search"
              placeholder="输入课程名称搜索"
            />
          </van-cell-group>
        </van-col>
        <van-col span="6">
            <span class="ljis querens" v-if="value.length>0" @click="courselist1">确认</span>
            <span class="ljis quxiaos" v-else @click="fan">取消</span>
        </van-col>
      </van-row>
    </van-sticky>
    <div class="magtop" v-if="remns==0">
        <div class="remens">热门搜索</div>
        <div v-for="(list, index) in courlist"
        class="zitixian"
        :key="index"
         @click="dianjis(list.lessonId,list.courseTypeid)">
           <span :class="index==0?'h':index==1?'hu':index==2?'huf':'qianhuif'">{{index+1}}</span> {{ list.courseName }}
        </div>
    </div>
    <div class="magtop">
      <van-row
            gutter="10"
            class="mag"
            v-for="(list, index) in courlist1"
            :key="index"
            @click="dianjis(list.lessonId,list.courseTypeid)"
          >
            <van-col span="8" class="posjhu">
              <img
                :src="list.serverHttp+list.courseImg"
                width="100%"
                class="kecimg"
                v-if="list.courseImg&&list.courseImg!==''"
              />
              <img
                src="../../assets/img/zbmr.png"
                width="100%"
                class="kecimg"
                v-else
              />
              <span class="fpoad-span" v-if="list.courseTypeid==2">{{ list.courseHour }}课时</span>
              <span class="fpoad-span" v-if="list.courseTypeid==1">
                <span style="font-size: 12px !important;" v-if="list.liveStatus==2">未开始</span>
                <span style="font-size: 12px !important;" v-if="list.liveStatus==3">已结束</span>
                <span style="font-size: 12px !important;" v-if="list.liveStatus==1">直播中</span>
                <span style="font-size: 12px !important;" v-if="list.liveStatus==4">查看回放</span>
              </span>
            </van-col>
            <van-col span="16">
              <van-col span="24" class=" touhei heise " style="max-width: 100%;" :class="list.courseTypeid==1?'':'gaodu'">
                {{ list.courseName }}
              </van-col>
              <van-col span="24" style="margin-top: 10px;" v-if="list.courseTypeid==1">
              <van-col span="24" class="spanhong">
                <span>{{ yue(list.beginTime) }}</span>
                <span>{{ getWeekDay(list.beginTime) }}</span>
                <span>{{ slices(list.beginTime, list.endTime) }}</span>
              </van-col>
            </van-col>
              <van-col span="24">
                <van-col span="24" class="spanhong">
                  <span class="lanm biao-span" v-if="list.classifyName">{{
                    list.classifyName
                  }}</span>
                  <span class="hongmu biao-span" v-if="list.courseLimit == 10"
                    >公开课</span
                  >
                  <span class="huanggu biao-span" v-if="list.courseLimit !== 10"
                    >授权观看</span
                  >
                  <span class="magtop chefudui huisezi"
                    >{{ list.courseViewnum }}人学习</span
                  >
                </van-col>
              </van-col>
            </van-col>
          </van-row>
    </div>
    <van-empty
      class="custom-image"
      :image="img"
      v-if="courlist1.length == 0&&zhan==0"
      description="暂时没有您搜索的课程"
    />
    <dibu class="dibu"></dibu>
  </div>
</template>

<script>
import { courselist } from "@/api/home";
export default {
  data() {
    return {
      show: false,
      img: require("../../assets/img/kong.png"),
      courlist: [],
      courlist1: [],
      value: "",
      zhan:1,
      remns:0,
      famousTeacherId: null
    };
  },
  watch: {
    value(){
        if(this.value.length==0){
            if(this.courlist1.length==0){
                this.remns=0
                this.zhan=1
            }
        }
    }
  },
  components: {},
  methods: {
    courselist() {
      let that = this;
      let params = {
        curPage: 1,
        pageSize: 5,
        courseState: 1,
        // courseTypeid: 2,
        groupId: 1,
        courseRecomend: 1,
      };
      courselist(params)
        .then((res) => {
            that.courlist=res.data.data.dataList
        })
        .catch(() => {

        });
    },
    courselist1() {
      let that = this;
      let params = {
        curPage: 1,
        pageSize: 100,
        courseState: 1,
        // courseTypeid: 2,
        groupId: 1,
        courseName:that.value,
        famousTeacherId: this.famousTeacherId
      };
      courselist(params)
        .then((res) => {
            that.courlist1=res.data.data.dataList
            if(that.courlist1.length>0){
                that.zhan=1
            }else{
                that.zhan=0
            }
            that.remns=1
        })
        .catch(() => {

        });
    },
    dianjis(s,d) {
      if(d==2){
        this.$router.push({
        path: "/indexvideo",
        query: {
          id: s,
        },
      });
      }else{
        this.$router.push({
        path: "/video",
        query: {
          id: s,
          t: Date.now()
        },
      });
      }
    },
    fan(){
         this.$router.go(-1)
    },
    yue(s) {
      if(s){
        return s.slice(5, 11);
      }
    },
    yuetu(s) {
      s = s / 10000;
      s = s.toFixed(2);
      return s + "万";
    },
    getWeekDay(dateString) {
      if(!dateString){
        return false
      }
      dateString = dateString.slice(0, 10);
      var dateArray = dateString.split("-");
      var date = new Date(
        dateArray[0],
        parseInt(dateArray[1] - 1),
        dateArray[2]
      );
      return "周" + "日一二三四五六".charAt(date.getDay());
    },
    slices(s, d) {
      if(s&&d){
        return s.slice(10, 16) + " -" + d.slice(10, 16);
      }
    },
  },
  mounted() {
    this.famousTeacherId = this.$route.query.famousTeacherId;
    this.courselist();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/index/search.vue